import { css } from '@emotion/css';
import { HexagonOutlined } from '@mui/icons-material';
import { Box, Divider, Grid2, Stack, Typography } from '@mui/material';
import React, { Fragment } from 'react';
import { COLOR_BORDER_PRIMARY } from './theme';
const style = {
    margin: 'auto',
    overflow: 'clip',
    userSelect: 'none',
    width: '480px',
};
// @TODO retrieve these from an actions source-of-truth at a later point
const actionPrompts = [
    { hotkey: 'Ctrl+Alt+N', label: 'Create something new' },
    { hotkey: 'Ctrl+O', label: 'Open an existing project' },
];
const interleave = (a, inter) => [].concat(...a.map((n) => ([n, inter]))).slice(0, -1);
const HotkeyInputGroup = ({ children }) => React.createElement("span", { className: css({ marginRight: '0.25em' }) }, children);
const HotkeySegment = ({ children }) => (React.createElement(Typography, { display: "inline-block", className: css({
        border: `1px solid ${COLOR_BORDER_PRIMARY}`, borderRadius: '3px',
        padding: '0.1em 0.4em',
        margin: '0 0.5em',
    }) }, children));
const HotkeySegmentJoin = () => React.createElement("span", { className: css({ margin: '0 .1em' }) }, "\uFF0B");
const Hotkey = ({ keys }) => (React.createElement(Fragment, null, keys.split(/\s+/)
    .map((inputGroup) => inputGroup.split('+')
    .map((segment) => (React.createElement(HotkeySegment, null, segment)))).reduce((acc, segments) => ([
    ...acc,
    React.createElement(HotkeyInputGroup, { key: segments.join('') }, ...interleave(segments, React.createElement(HotkeySegmentJoin, null)))
]), [])));
const EmptyEditorsView = () => {
    return (React.createElement(Stack, { alignItems: "center", justifyContent: "center", flexGrow: "1", sx: style },
        React.createElement(Box, { sx: { color: 'rgb(38 38 38)', position: 'relative' } },
            React.createElement(HexagonOutlined, { sx: {
                    filter: 'drop-shadow(5px 5px 8px rgb(30 30 30))',
                    fontSize: '400px',
                } }),
            React.createElement(Typography, { sx: {
                    position: "absolute",
                    top: '65%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    textShadow: '3px 5px 2px rgb(30 30 30)',
                }, variant: "h1", fontWeight: 700 }, "hX")),
        React.createElement(Stack, { alignItems: "stretch" },
            React.createElement(Divider, { textAlign: "center" },
                React.createElement(Typography, { variant: "h3", sx: {
                        color: '#66bb6a',
                        textShadow: '3px 5px 2px rgb(28 28 28)',
                    } }, "Start Building")),
            React.createElement(Box, { alignSelf: "center", sx: { padding: '1em 3.5em 0em 3.5em' } },
                React.createElement(Grid2, { container: true, rowSpacing: { md: 2 } }, actionPrompts.map(({ label, hotkey }) => (React.createElement(Fragment, { key: hotkey },
                    React.createElement(Grid2, { size: 6, alignSelf: "center" },
                        React.createElement(Hotkey, { keys: hotkey })),
                    React.createElement(Grid2, { size: 6, alignSelf: "center" }, React.createElement(Typography, null, label))))))))));
};
export default EmptyEditorsView;
//# sourceMappingURL=EmptyEditorsView.js.map